/**
 * Turns an API failure into something a form can show the user.
 *
 * express-validator answers a bad request with
 *   { errors: [{ path: 'max_capacity', msg: 'Capacity must be positive', ... }] }
 * which every form was throwing away in favour of "Failed to create series". The user got
 * no way to tell what was wrong, let alone fix it.
 */

export function parseFieldErrors(err) {
  const errors = err?.response?.data?.errors;

  if (!Array.isArray(errors)) {
    return {};
  }

  return errors.reduce((acc, item) => {
    const path = item.path || item.param;
    if (path && !acc[path]) {
      acc[path] = item.msg || 'Invalid value';
    }
    return acc;
  }, {});
}

/**
 * A single line for the summary, falling back to whatever the API did say.
 */
export function parseErrorMessage(err, fallback) {
  const data = err?.response?.data;

  if (data?.error) {
    return data.error;
  }

  const fieldErrors = parseFieldErrors(err);
  const messages = Object.values(fieldErrors);

  if (messages.length === 1) {
    return messages[0];
  }

  if (messages.length > 1) {
    return `${messages.length} fields need attention`;
  }

  return fallback;
}

/**
 * Field state for a DS field: 'error' when this field was rejected, otherwise the default.
 */
export function fieldState(fieldErrors, path) {
  return fieldErrors[path] ? 'error' : undefined;
}
